<script setup lang="ts">
const props = defineProps<{ icon: string; label: string; expanded?: boolean }>()
const isExpaned = ref(props.expanded || false)
const dialogIsExpaned = ref(false)
</script>
<template>
  <div class="wrapper my-1">
    <div v-if="!isExpaned" class="control-trigger only-phone-up">
      <Button
        :icon="`pi ${icon}`"
        aria-label="Lagermeny"
        plain
        text
        @click="isExpaned = !isExpaned"
      />
    </div>
    <div v-if="!dialogIsExpaned" class="control-trigger only-phone">
      <Button
        :icon="`pi ${icon}`"
        aria-label="Lagermeny"
        plain
        text
        @click="dialogIsExpaned = !dialogIsExpaned"
      />
    </div>
    <div v-if="isExpaned" class="control-box">
      <div class="header">
        <h4 class="heading font-medium text-lg">{{ label }}</h4>
        <Button icon="pi pi-times" plain text @click="isExpaned = !isExpaned" />
      </div>
      <slot />
    </div>
    <Dialog
      v-model:visible="dialogIsExpaned"
      modal
      :header="label"
      close-on-escape
      dismissable-mask
      position="center"
      style="max-width: 90%"
    >
      <slot />
    </Dialog>
  </div>
</template>
<style lang="scss" scoped>
.wrapper {
  position: relative;
  z-index: 1;
}
.control-item {
  margin-bottom: 8px;
  label {
    margin-left: 8px;
  }
}
.only-phone {
  display: inline-flex !important;
  @media (min-width: 481px) {
    display: none !important;
  }
}
.only-phone-up {
  display: none !important;
  @media (min-width: 481px) {
    display: inline-flex !important;
  }
}
.control-trigger {
  z-index: 1;
  border-radius: 2px;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.25);
  .p-button {
    background-color: white;
    z-index: 1;
  }
}
.control-box {
  z-index: 1;
  background-color: white;
  padding: 8px 16px;
  border-radius: 2px;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.25);
  z-index: 2;
  min-width: 200px;
  margin-left: 1rem;
  max-width: 320px;
  display: none;

  @media (min-width: 481px) {
    display: block;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-bottom: 16px;
    .heading {
      margin-bottom: 0;
    }
  }
}
</style>
